var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "w-full" }, [
    _c(
      "div",
      { staticClass: "h-full w-full" },
      [
        _vm.timeTrackerOpen
          ? _c("TimesheetTimeTrackerModal", {
              attrs: {
                currentUser: _vm.currentUser,
                activeActivity: _vm.activeActivity,
                canPause: _vm.canPause,
                activeTimeEntry: _vm.activeTimeEntry,
                propDate: _vm.trackedDate,
                propRangeStart: _vm.timerStart,
                propRangeEnd: _vm.timerEnd,
                currentCellTime: _vm.currentCellTime,
                checkDateWeekDisable: _vm.checkDateWeekDisable,
                companId: _vm.company[0]?.id,
                timesheetId: _vm.timeSheetId,
              },
              on: {
                close: function ($event) {
                  return _vm.closeTimeTrackerModal()
                },
              },
            })
          : _vm._e(),
        _vm.timeTrackerOpenManual
          ? _c("TimesheetTimeTrackerModalManual", {
              attrs: {
                currentUser: _vm.currentUser,
                activeActivity: _vm.activeActivity,
                canPause: _vm.canPause,
                activeTimeEntry: _vm.activeTimeEntry,
                propDate: _vm.trackedDate,
                propRangeStart: _vm.timerStart,
                propRangeEnd: _vm.timerEnd,
                currentCellTime: _vm.currentCellTime,
                checkDateWeekDisable: _vm.checkDateWeekDisable,
                companId: _vm.company[0]?.id,
                timesheetId: _vm.timeSheetId,
              },
              on: {
                close: function ($event) {
                  return _vm.closeTimeTrackerModal(true)
                },
              },
            })
          : _vm._e(),
        _vm.submitTimeModalOpen
          ? _c("SubmitTimeModal", {
              attrs: {
                activityTitle: _vm.activeActivity.title,
                time: _vm.elapsedTime,
              },
              on: { closeSubmitTimeModal: _vm.closeSubmitTimeModal },
              model: {
                value: _vm.submitTime,
                callback: function ($$v) {
                  _vm.submitTime = $$v
                },
                expression: "submitTime",
              },
            })
          : _vm._e(),
        _vm.rejectReasonModalOpen
          ? _c("RejectReasonModal", {
              attrs: { rejectionReason: _vm.rejectionReason },
              on: {
                close: function ($event) {
                  _vm.rejectReasonModalOpen = false
                },
              },
            })
          : _vm._e(),
        _c(
          "LoadingOverlay",
          {
            attrs: {
              loading: _vm.isLoaded,
              hasData: _vm.isTimesheetEmpty,
              customPlaceholderMessage: !_vm.isTimesheetEmpty
                ? "There are no timesheets"
                : "Information is currently unavailable",
            },
            scopedSlots: _vm._u([
              {
                key: "empty_placeholder",
                fn: function () {
                  return [
                    _c("EmptyListImageProjects", { staticClass: "emptyStyle" }),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _c(
              "div",
              {
                staticClass: "h-auto",
                class: _vm.weekDisable
                  ? ` p-5 timesheet_container timesheet_disable`
                  : ` p-5 timesheet_container`,
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "mb-8 flex warningText flex-row justify-between w-full",
                  },
                  [
                    _c("div", { staticClass: "flex flex-row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "mt-1 h-4 w-auto",
                          attrs: { alt: "delete notes" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c(
                                "g",
                                { attrs: { id: "Icon / InfoCircleFilled" } },
                                [
                                  _c("path", {
                                    attrs: {
                                      id: "Vector",
                                      d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                                      fill: "#070823",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "p",
                        { staticClass: "child text-sm sm:text-base ml-2" },
                        [
                          _vm._v(
                            " The calendar is not reflective of your timesheet. Please log those hours in the timesheets feature. "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c("vue-cal", {
                  ref: "vuecalRef",
                  attrs: {
                    events: _vm.events,
                    "time-from": 7 * 60,
                    "time-to": 25 * 60,
                    "time-cell-height": 120,
                    "twelve-hour": true,
                    id: "vuecal",
                    "hide-view-selector": "",
                    "disable-views": ["years", "year", "month", "day"],
                    "min-event-width": 100,
                    "today-button": "",
                    allDayBarHeight: "50px",
                    editableEvents: _vm.canEdit,
                  },
                  on: {
                    "cell-click": _vm.onCellClick,
                    "event-drag-create": _vm.openTimeTrackerModal,
                    "event-duration-change": _vm.updateTrackedTimes,
                    "event-drop": _vm.updateTrackedTimes,
                    ready: function ($event) {
                      return _vm.getWeek($event)
                    },
                    "view-change": function ($event) {
                      return _vm.getWeek($event)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "today-button",
                      fn: function () {
                        return [
                          _c("span", { staticClass: "tota_hours_txt" }, [
                            _vm._v("Total visit hours booked:"),
                          ]),
                          _c("span", { staticClass: "total_hours" }, [
                            _vm._v(_vm._s(_vm.getRanderWeekTotalTime)),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "title",
                      fn: function ({ view }) {
                        return [
                          view.id === "week"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "font-outfit font-semibold text-xl w-full justify-between",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.dateRange(view)) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "weekday-heading",
                      fn: function ({ heading }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-outfit flex flex-col font-medium text-xl font-medium h-18",
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(heading.date.format("DD"))),
                              ]),
                              _c("span", { staticClass: "weekday_name" }, [
                                _vm._v(_vm._s(heading.label.substring(0, 3))),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "time-cell",
                      fn: function ({ hours, minutes }) {
                        return [
                          _c(
                            "div",
                            {
                              class: {
                                "vuecal__time-cell-line": false,
                                hours: !minutes,
                              },
                            },
                            [
                              !minutes
                                ? _c(
                                    "strong",
                                    { staticStyle: { "font-size": "15px" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            hours % 12 === 0 ? 12 : hours % 12
                                          ) +
                                          " "
                                      ),
                                      hours < 12
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "15px",
                                              },
                                            },
                                            [_vm._v("AM")]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "15px",
                                              },
                                            },
                                            [_vm._v("PM")]
                                          ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { "font-size": "11px" } },
                                    [_vm._v(_vm._s(minutes))]
                                  ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell-content",
                      fn: function ({ cell, view, events }) {
                        return [
                          ["week", "day"].includes(view.id) && !events.length
                            ? _c("span", { staticClass: "vuecal__no-event" })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "event",
                      fn: function ({ event }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "cursor-pointer w-full h-full timer_cell_parent min-h-4",
                              on: {
                                click: function ($event) {
                                  return _vm.openTimeTrackerModal(event)
                                },
                              },
                            },
                            [
                              event.class !== "TIMER"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "vuecal__event-time flex flex-col items-start font-outfit text-sm ml-2",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            event.start.formatTime("h:mm AM")
                                          ) +
                                          " - " +
                                          _vm._s(
                                            event.end.formatTime("h:mm AM")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-start justify-between font-bold font-outfit ml-2 mr-2 mt-2",
                                    },
                                    [
                                      _c("span", {
                                        attrs: { id: "timerLabel" },
                                      }),
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.stopButton.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "rounded-full hover:bg-white hover:text-black px-2 hover:font-bold",
                                            },
                                            [_vm._v(" STOP ")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "vuecal__event-content flex flex-col items-start font-outfit ml-2 text-base",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex justify-between items-center w-full",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-base font-medium",
                                        },
                                        [_vm._v(_vm._s(event.content) + " ")]
                                      ),
                                      _c("EditIconVue", {
                                        staticClass: "time_edit_icon mr-1",
                                      }),
                                    ],
                                    1
                                  ),
                                  event.class !== `TIMER`
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "text-base font-medium",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                (event.end - event.start) /
                                                1000 /
                                                60 /
                                                60
                                              ).toFixed(0)
                                            ) + "H"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  event.class === `TIMER`
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-base font-medium rounded-full px-4 border border-white mt-2",
                                        },
                                        [_vm._v(" Active Timer ")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }